<app-fixed-content-page
  [content]="content"
/>

<ng-template #content>
  <h1 class="text-bold m-b-5 m-t-5">Welcome to the Aptem Assess cognitive assessment</h1>

  <div class="content-layout-column">
    <div>
      <p>
        You will receive an unique invitation link, that must be used to complete the assessment.
      </p>

      <p class="mb-0">
        For more information, visit <a href="https://aptemassess.co.uk" target="_blank">Aptem Assess</a>
      </p>
    </div>

    <div>
      <!-- NOTE: To be refactored -->
      <div class="details-container rounded-8 overflow-hidden">
        <div class="tip-header d-flex align-items-center p-2">
          <div class="bg-white rounded-circle p-2 m-2">
            <svg-icon
              src="assets/icons/help.svg"
              [svgStyle]="{ 'width.px': 24 }"
            >
            </svg-icon>
          </div>
          <span class="text-white font-size-18 fw-bolder m-2">The purpose of the cognitive assessment</span>
        </div>
        <div class="d-md-flex align-items-center">
          <div class="m-3 m-md-0 text-center text-md-start">
            <div class="p-3 p-lg-4">
              <ul class="assessment-desc pt-1 ps-3">
                <li class="pb-3">
                  Cognitive assessments measure your thinking abilities, including; reasoning, perception, memory,
                  problem-solving skills and verbal reasoning.
                </li>
                <li>
                  Assessing these areas indicates whether you may require additional support with your learning, to
                  maximise your chance of success.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
